import { BlockConfigurationObject } from "../../../interfaces/block-configuration-object.interface";
import { Match } from "../../../interfaces/match.interface";
import { BetService } from "../../../services/bet.service";
import { GeneralService } from "../../../services/general.service";
import { MatchService } from "../../../services/match.service";

export class PreMatchPredictionsController {
	preMatchSelectedMarket = "line";
	match: Match;
	preMatchMarketList = {};
	totalDataUnavailable = false;
	lineDataUnavailable = false;
	btsDataUnavailable = false;
	firstSetDataUnavailable = false;
	highOpenDataUnavailable = false;
	fourOversDataUnavailable = false;
	firstWicketDataUnavailable = false;
	mostSixesDataUnavailable = false;
    articleLink: string;
    
	withinMatch = false;
	displayMode: string;
	awayBeforeHome: boolean;

	generalService: GeneralService;
	matchService: MatchService;
	betService: BetService;
	configurationObject: BlockConfigurationObject;

	/* @ngInject */
	constructor(
		generalService: GeneralService, 
		matchService: MatchService, betService: BetService, 
		configurationObject: BlockConfigurationObject) {
		this.generalService = generalService;
		this.matchService = matchService;
		this.betService = betService;
		this.configurationObject = configurationObject;
	}

	$onInit(): void {
		if (this.match.MatchData.Sport.toLowerCase() === "mlb") {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "total", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
				{market: "line", label: this.generalService.localeTerm("line_mlb"), available: !this.lineDataUnavailable},
			];
		} else if (this.match.MatchData.Sport.toLowerCase() === "bbl") {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "high-open", label: this.generalService.localeTerm("high-open_short"), available: !this.highOpenDataUnavailable},
				{market: "four-overs", label: this.generalService.localeTerm("four-overs_short"), available: !this.fourOversDataUnavailable},
				{market: "first-wicket", label: this.generalService.localeTerm("first-wicket_short"), available: !this.firstWicketDataUnavailable},
				{market: "most-sixes", label: this.generalService.localeTerm("most-sixes"), available: !this.mostSixesDataUnavailable}
			];
		} else if (this.generalService.isSoccer(this.match.MatchData.Sport)) {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "cs", label: "Correct Score", available: true},
				{market: "total", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
				{market: "bts", label: this.generalService.localeTerm("bts_short"), available: !this.btsDataUnavailable}
			];
		} else if (this.match.MatchData.Sport.toLowerCase() === "nhl") {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "total", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
				{market: "line", label: this.generalService.localeTerm("line_nhl"), available: !this.lineDataUnavailable},
			];
		} else if (this.match.MatchData.Sport.toLowerCase() === "ten") {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "gametotal", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
				{market: "gameline", label: this.generalService.localeTerm("game_line"), available: !this.lineDataUnavailable},
				{market: "firstset", label: "1st Set", available: !this.firstSetDataUnavailable},
			];
		} else if (["soo", "nrl", "afl"].includes(this.match.MatchData.Sport.toLowerCase())) {
			this.preMatchSelectedMarket = "h2h";

			this.preMatchMarketList = [
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
				{market: "line", label: this.generalService.localeTerm("line"), available: !this.lineDataUnavailable},
				{market: "total", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
			];
		
		} else {
			if (this.lineDataUnavailable) {
				this.preMatchSelectedMarket = "h2h";
			} else {
				this.preMatchSelectedMarket = "line";
			}

			this.preMatchMarketList = [
				{market: "line", label: this.generalService.localeTerm("line"), available: !this.lineDataUnavailable},
				{market: "total", label: this.generalService.localeTerm("total"), available: !this.totalDataUnavailable},
				{market: "h2h", label: this.generalService.localeTerm("h2h_short"), available: true},
			];
		}
	}

	setPreMatchSelectedMarket(market: string): void {
		this.preMatchSelectedMarket = market;
	}

	getScorelineOpacity(homeScore: number, awayScore: number): number {
		let value: number;
		if (homeScore > awayScore) {
			value = this.match.PreData[`CS_H${homeScore}_${awayScore}_Pct`];
		} else if (awayScore > homeScore) {
			value = this.match.PreData[`CS_A${awayScore}_${homeScore}_Pct`];
		} else {
			value = this.match.PreData[`CS_D${homeScore}_${awayScore}_Pct`];
		}

		if (!value) {
			return 0;
		}
		
		return value;
	}
	
	getScorelinePercentage(homeScore: number, awayScore: number): string {
		let value: string;
		if (homeScore > awayScore) {
			value = this.match.PreData[`CS_H${homeScore}_${awayScore}_Pct`];
		} else if (awayScore > homeScore) {
			value = this.match.PreData[`CS_A${awayScore}_${homeScore}_Pct`];
		} else {
			value = this.match.PreData[`CS_D${homeScore}_${awayScore}_Pct`];
		}

		if (!value) {
			return "-";
		}
		
		return (parseFloat(value) * 100).toFixed(0) + "%";
	}

    goToLink = (link:string): void => {
        if(this.configurationObject.publicationTheme === 'ball-is-life' )
            {
                window.open(link, '_blank');
            }
    }
}